<template>
  <div class="strength">
    <div class="header">
      <div class="left">ABOUT US</div>
      <div class="right">关于我们</div>
    </div>
    <div class="header_title">
      <h2 class="current">公司简介</h2>
      <!-- <div class="border"></div>
      <h2>招聘信息</h2> -->
    </div>
    <div class="desc_company">
      <img src="../assets/img/3_1.jpg" alt="公司简介">
      <div class="desc_company_box">
        <h3>海南掌上能量传媒有限公司</h3>
        <p class="intro">速绿充电成立于2020年1月，总部坐落于北京，是国内领先的共享充电平台，更是传统充电行业的颠覆者，让绿色的生活方式和快速的充电体验结合成一种习惯。</p>
        <ul>
          <li class="pr br">
            <h4>团队介绍</h4>
            <p>专业的研发及技术团队，现有团队3000余人，其中核心技术成员300余人，自主研发，自主生产，建有完善的技术管理与质量保证体系。</p>
          </li>
          <li class="pl pr br">
            <h4>公司愿景</h4>
            <p>网点遍布全国，以智能充电宝租赁终端设备实现手机随时随地免押借用充电宝，大幅减少能源浪费，让你的手机永不断电！</p>
          </li>
          <li class="pl">
            <h4>政策红利</h4>
            <p>借国家海南自贸港的政策东风和注册制的东风，公司快速发展寻求在国内上市，并在海外大力拓展市场。</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="desc_technology">
        <h3>国家高新技术企业，发明专利，实用新型，外观专利</h3>
        <img src="../assets/img/3_2.jpg" alt="国家高新技术企业">
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      
    };
  },
  components: {},
  mounted () {},
  methods: {}
}
</script>

<style lang='scss' scoped>
  h1, h2, h3, h4, h5, p, ul, li {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }
  ul {
    list-style: none;
  }
  .strength {
    width: 100%;
  }
  .header {
    background-color: #2fb15a;
    height: .42rem;
    padding-left: 0.25rem;
    line-height: .44rem;
    text-align: left;
  }
  .header div {
    display: inline-block;
    vertical-align: top;
  }
  .header .left {
    font-size: 0.32rem;
    color: #e8e8e8;
    font-weight: 700;
  }
  .header .left::after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 0.12rem;
    margin: -0.08rem 0.12rem 0 0.15rem;
    border-right: 1px solid #78cd94;
  }
  .header .right {
    font-size: 0.24rem;
    color: #fff;
  }
  .header_title {
    height: 0.68rem;
    padding-top: 0.32rem;
    font-size: 0.22rem;
  }
  .header_title h2 {
    display: inline-block;
    vertical-align: middle;
    height: 0.36rem;
    -webkit-border-radius: .2rem;
    -ms-border-radius: .2rem;
    -o-border-radius: .2rem;
    border-radius: .2rem;
    line-height: 0.36rem;
    font-size: 0.22rem;
    color: #1b1b1b;
    font-weight: 700;
  }
  .header_title .border {
    display: inline-block;
    vertical-align: middle;
    width: 0.03rem;
    height: 0.35rem;
    margin: 0 0.62rem;
    background-color: #2fb15a;
  }
  .header_title h2.current {
    padding: 0 0.12rem;
    background-color: #2fb15a;
    color: #fff;
  }
  .desc_company img {
    width: 100%;
    vertical-align: top;
  }
  .desc_company_box {
    padding: 0 0.28rem;
    text-align: left;
    overflow: hidden;
  }
  .desc_company_box h3 {
    height: 0.56rem;
    font-size: 0.32rem;
    color: #2fb15a;
    text-align: center;
    font-weight: 700;
  }
  .desc_company_box .intro {
    margin-bottom: 0.4rem;
    line-height: 0.28rem;
    font-size: 0.18rem;
    color: #3e3a39;
  }
  .desc_company_box ul {
    display: flex;
  }
  .desc_company_box li {
    flex: 1;
  }
  .desc_company_box .pl {
    padding-left: .38rem;
  }
  .desc_company_box .pr {
    padding-right: .38rem;
  }
  .desc_company_box .br {
    border-right: 1px solid #2fb15a;
  }
  .desc_company_box li h4 {
    height: 0.48rem;
    font-size: 0.24rem;
    color: #1b1b1b;
    text-align: center;
    font-weight: 700;
  }
  .desc_company_box li p {
    line-height: 0.32rem;
    font-size: 0.18rem;
    color: #1b1b1b;
    text-align: justify;
    font-weight: 600;
  }
  .desc_technology {
    text-align: center;
    margin: 0.68rem 0.25rem 0.2rem;
  }
  .desc_technology h3 {
    margin-bottom: 0.28rem;
    font-size: 0.26rem;
    color: #2fb15a;
    font-weight: 700;
  }
  .desc_technology img {
    width: 100%;
  }
</style>